var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":"点击重新获取最新数据"}},[_c('Tag',{attrs:{"color":"#2EF1F3"},nativeOn:{"click":function($event){return _vm.refresh.apply(null, arguments)}}},[_c('Icon',{staticClass:"item-icon",staticStyle:{"position":"relative","top":"-1px"},attrs:{"type":"md-refresh","size":"18"}}),_vm._v(" 刷新数据")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }